import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
// 招商银行APP
import Cookie from '../utils/cookie';
import Url from '../utils/url';
import axios from 'axios';
import env from '../env';
import cmblapi from '@myfe/cmblapi';
var isProd = env.isProduct || env.isPpe;
var UA = (navigator.userAgent + '').toLowerCase();
var getLocationByCmb = function getLocationByCmb() {
  return new Promise(function (resolve, reject) {
    if (env.isLocal || UA.indexOf('mpbank') === -1) {
      // 开发本地返回上海
      resolve({
        latitude: 31.231706,
        longitude: 121.472644
      });
    } else {
      cmblapi.getLocation({
        mapType: 'gd',
        useCache: true,
        success: function success(res) {
          resolve(res);
        },
        fail: function fail(res) {
          resolve({
            latitude: 31.231706,
            longitude: 121.472644
          });
        }
      });
    }
  });
};
export default {
  appName: 'cmb_app',
  useKNB: false,
  sellChannel: 28,
  theme: 'maoyan',
  hostPrefix: '//show.maoyan.com/qqw',
  hostBetaPrefix: '//show.test.maoyan.com/qqw',
  ajaxUrl: '//show.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: '//show.test.maoyan.com/maoyansh/myshow/ajax',
  tokenCookie: '_source__from_',
  linkMap: {
    // 地址跳转映射
    // 首页
    '/myshow/': '/',
    '/myshow/index.html': '/',
    '/movieshow/index.html': '/',
    // 列表相关
    '/movieshowlist/graphic-detail.html': '/graphic',
    '/movieshowlist/show-ticket.html': '/list',
    '/movieshowlist/show-merchant.html': '/merchants',
    '/movieshowlist/show-detail.html': '/detail',
    '/movieshowlist/group.html': '/group',
    '/movieshowlist/search.html': '/search',
    '/movieshowlist/show-shop.html': '/shop',
    // 下单相关
    '/movieshoworder/goods.html': '/tickets',
    '/movieshoworder/pre-order.html': '/confirm',
    '/movieshoworder/area.html': '/partition',
    '/movieshoworder/add-address.html': '/add-addr',
    '/movieshoworder/choose-address.html': '/choose-addr',
    '/movieshoworder/coupon-detail.html': '/coupon-detail',
    '/movieshoworder/seats.html': '/seats',
    '/movieshoworder/coupon.html': '/coupon',
    '/movieshoworder/order-detail.html': '/order-detail',
    '/movieshoworder/order-list.html': '/order-list',
    '/movieshoworder/real-names.html': '/realname',
    '/movieshoworder/seat-area.html': '/seat-area',
    '/movieshoworder/select-seats.html': '/select-seats',
    '/movieshoworder/search-order.html': '/search-order'
  },
  getUserInfo: function getUserInfo() {
    var cookieInfoArr = (Cookie.get('_source__from_') || '').split('||');
    return {
      token: cookieInfoArr[1] || '',
      userId: cookieInfoArr[2] || ''
    };
  },
  getLocation: function getLocation() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var localtion;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getLocationByCmb();
          case 3:
            localtion = _context.sent;
            return _context.abrupt("return", {
              lat: localtion.latitude || 31.231706,
              lng: localtion.longitude || 121.472644
            });
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.log('定位', _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }))();
  },
  getCity: function getCity() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var localtion, lat, lng, preUrl, instance, date, res, _res$data, code, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getLocationByCmb();
          case 2:
            localtion = _context2.sent;
            lat = localtion.latitude || 31.231706;
            lng = localtion.longitude || 121.472644;
            preUrl = isProd ? 'https://show.maoyan.com/maoyansh/myshow/ajax' : 'http://show.test.maoyan.com/maoyansh/myshow/ajax';
            instance = axios.create({
              baseURL: "".concat(preUrl),
              timeout: 15000
            });
            date = new Date().getTime();
            _context2.next = 10;
            return instance.get("/city/queryMTCity?lat=".concat(lat, "&lng=").concat(lng, "&sellchannel=28&t=").concat(date));
          case 10:
            res = _context2.sent;
            _res$data = res.data, code = _res$data.code, data = _res$data.data;
            if (!(code === 200)) {
              _context2.next = 17;
              break;
            }
            Cookie.set('cityid', data.id);
            return _context2.abrupt("return", {
              cityId: data.id,
              cityName: data.nm,
              pinyin: data.py
            });
          case 17:
            // 默认投放上海
            Cookie.set('cityid', 10);
            return _context2.abrupt("return", {
              cityId: 10,
              cityName: '上海',
              pinyin: 'shanghai'
            });
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  /**
   * 登录方法
   */
  login: function login() {
    if (location.href.indexOf('/cmbApp/auth') < 0) {
      var hash = location.hash;
      location.replace("#/cmbApp/auth".concat(hash.replace('#', '')));
    }
  }
};